import { c as _c } from "react/compiler-runtime";
import { FormSelect, FormSelectProps, Hint } from 'shared/components';
import { useSetDefaultSenderEmail } from 'shared/components/sender-email-select/hooks/use-set-default-sender-email';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
import LinkWithoutPrefetch from '../link-without-prefetch';
import TransLoco from '../trans-loco';
export interface SenderEmailSelectProps extends Omit<FormSelectProps<string>, 'data'> {
  hintLabel?: string;
  noHint?: boolean;
}
function SenderEmailSelect(t0) {
  const $ = _c(25);
  let hintLabel;
  let noHint;
  let onChange;
  let rest;
  let value;
  if ($[0] !== t0) {
    ({
      value,
      onChange,
      hintLabel,
      noHint,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = hintLabel;
    $[2] = noHint;
    $[3] = onChange;
    $[4] = rest;
    $[5] = value;
  } else {
    hintLabel = $[1];
    noHint = $[2];
    onChange = $[3];
    rest = $[4];
    value = $[5];
  }
  const {
    t
  } = useLocoTranslation();
  const {
    senderEmailValidList
  } = useSetDefaultSenderEmail(value, onChange);
  let t1;
  if ($[6] !== senderEmailValidList) {
    t1 = senderEmailValidList?.map(_temp);
    $[6] = senderEmailValidList;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  const senderEmailOptions = t1;
  const t2 = value || "";
  const t3 = !noHint;
  let t4;
  if ($[8] !== hintLabel || $[9] !== t) {
    t4 = hintLabel ? hintLabel : <TransLoco t={t} i18nKey="dashboard.email.add_new_email_hint" components={{
      a: <LinkWithoutPrefetch target="_blank" href="/profile/mailing-settings#verified-email-addresses" className="link" />
    }} />;
    $[8] = hintLabel;
    $[9] = t;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t4) {
    t5 = <div>{t4}</div>;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] !== t) {
    t6 = t("dashboard.email.sender_email_address");
    $[13] = t;
    $[14] = t6;
  } else {
    t6 = $[14];
  }
  let t7;
  if ($[15] !== t3 || $[16] !== t5 || $[17] !== t6) {
    t7 = <Hint showHint={t3} label={t5}>{t6}</Hint>;
    $[15] = t3;
    $[16] = t5;
    $[17] = t6;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== onChange || $[20] !== rest || $[21] !== senderEmailOptions || $[22] !== t2 || $[23] !== t7) {
    t8 = <FormSelect data={senderEmailOptions} value={t2} onChange={onChange} withoutCloseIcon={true} label={t7} {...rest} />;
    $[19] = onChange;
    $[20] = rest;
    $[21] = senderEmailOptions;
    $[22] = t2;
    $[23] = t7;
    $[24] = t8;
  } else {
    t8 = $[24];
  }
  return t8;
}
function _temp(t0) {
  const {
    email
  } = t0;
  return {
    id: email,
    caption: email
  };
}
export default SenderEmailSelect;